export default __webpack_public_path__ + "8aca7204924afdff0ef148afb8d3dc2d.jpg";